import BenDocument from "./ben-document";

export default BenDocument;
